import { createFileRoute, Link } from '@tanstack/react-router';
import { Envelope } from '@phosphor-icons/react';
import { AuthHeading } from '../../../../../components/auth/auth-heading';
import { SocialAuthButtons } from '../../../../../components/auth/social-auth-buttons';
import { TermsLinks } from '../../../../../components/auth/terms-links';
import { Icon } from '../../../../../components/Icon';
import { Banner } from '../../../../../components/ui/banner';
import { buttonClassName } from '../../../../../components/ui/button';
import { requireAssessment } from '../../../../../lib/guards';
import { useOnboardingStore } from '../../../../../lib/onboarding-store';

export const Route = createFileRoute('/subdomain/app/_auth/sign-up/')({
  // Creating an account comes after the assessment; opened directly, resume the assessment instead.
  beforeLoad: () => requireAssessment(),
  component: SignUpChooser,
});

function SignUpChooser() {
  const businessName = useOnboardingStore((s) => s.draft.businessName);

  return (
    <>
      {businessName ? <Banner tone="success">Your audit for {businessName} is ready to run</Banner> : null}
      <AuthHeading
        title="Time to save your business profile"
        subtitle="Create your account to keep your audit, track progress and chat with your team."
      />

      {/* A social sign-up has no verify step, so it returns straight to the audit screen. */}
      <SocialAuthButtons callbackPath="/audit">
        <Link to="/subdomain/app/sign-up/email" className={buttonClassName({ variant: 'secondary', fullWidth: true })}>
          <Icon icon={Envelope} size="xl" />
          Sign up with email
        </Link>
      </SocialAuthButtons>

      <p className="text-body-xsmall text-text-tertiary">
        By continuing you agree to our <TermsLinks />.
      </p>
    </>
  );
}
